import React from 'react'
import './footer.css'

function Footer () {
  return (
    <section class="footer">
        <div class="footer-left">
            <a href="">Bhagwati Trading</a>
            <h2>Connect with Us</h2>
        </div>
        <div class="footer-right">
            <div>
                <p class="footer-labels">Mailing Address</p>
                <p class="footer-value">Vishal Hotel, Dehri, Rohtas-821307, Bihar</p>
            </div>
            <div>
                <p class="footer-labels">Email Address</p>
                <p class="footer-value">bhagwatitradingdehri@gmail.com</p>
            </div>
            <div>
                <p class="footer-labels">Phone Number</p>
                <p class="footer-value">(+91) 9801750000</p>
            </div>
            <div>
                <p class="footer-labels">Version Date</p>
                <p class="footer-value">24/01/23 03:28AM</p>
            </div>
        </div>
    </section>
  )
}

export default Footer